/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Play_StoreInputs */

const en_google_play_store = /** @type {(inputs: Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Store`)
};

const ar_google_play_store = /** @type {(inputs: Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متجر جوجل بلاي`)
};

const de_google_play_store = /** @type {(inputs: Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Store`)
};

const es_google_play_store = /** @type {(inputs: Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienda Google Play`)
};

const fr_google_play_store = /** @type {(inputs: Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Store`)
};

const it_google_play_store = /** @type {(inputs: Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Store`)
};

const ja_google_play_store = /** @type {(inputs: Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Playストア`)
};

const ko_google_play_store = /** @type {(inputs: Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play 스토어`)
};

const pt_br_google_play_store = /** @type {(inputs: Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Store`)
};

const ru_google_play_store = /** @type {(inputs: Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Store`)
};

const th_google_play_store = /** @type {(inputs: Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ร้านค้า Google Play`)
};

const tr_google_play_store = /** @type {(inputs: Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Store`)
};

const zh_cn_google_play_store = /** @type {(inputs: Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play 商店`)
};

const zh_tw_google_play_store = /** @type {(inputs: Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play 商店`)
};

/**
* | output |
* | --- |
* | "Google Play Store" |
*
* @param {Google_Play_StoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const google_play_store = /** @type {((inputs?: Google_Play_StoreInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Play_StoreInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_google_play_store(inputs)
	if (locale === "ar") return ar_google_play_store(inputs)
	if (locale === "de") return de_google_play_store(inputs)
	if (locale === "es") return es_google_play_store(inputs)
	if (locale === "fr") return fr_google_play_store(inputs)
	if (locale === "it") return it_google_play_store(inputs)
	if (locale === "ja") return ja_google_play_store(inputs)
	if (locale === "ko") return ko_google_play_store(inputs)
	if (locale === "pt_br") return pt_br_google_play_store(inputs)
	if (locale === "ru") return ru_google_play_store(inputs)
	if (locale === "th") return th_google_play_store(inputs)
	if (locale === "tr") return tr_google_play_store(inputs)
	if (locale === "zh_cn") return zh_cn_google_play_store(inputs)
	return zh_tw_google_play_store(inputs)
});